import { TemplateRef, AfterViewInit, OnDestroy } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { UsuariosService, AuthenticationService, NotificacionesPushService, SubastasService, PujasService, PermissionsService } from '../_services';
import { environment } from '../../environments/environment';
import { SwPush } from '@angular/service-worker';
import { DomSanitizer } from '@angular/platform-browser';
import { isEmpty } from 'lodash';
import { OwlCarousel } from 'ngx-owl-carousel';
var SubastasDetalleComponent = /** @class */ (function () {
    function SubastasDetalleComponent(swPush, notificacionesPushService, subastasService, route, modalService, formBuilder, usuariosService, pujasService, router, authenticationService, sanitizer, permissionsService) {
        var _this = this;
        this.swPush = swPush;
        this.notificacionesPushService = notificacionesPushService;
        this.subastasService = subastasService;
        this.route = route;
        this.modalService = modalService;
        this.formBuilder = formBuilder;
        this.usuariosService = usuariosService;
        this.pujasService = pujasService;
        this.router = router;
        this.authenticationService = authenticationService;
        this.sanitizer = sanitizer;
        this.permissionsService = permissionsService;
        this.loading = false;
        this.submitted = false;
        this.currentUserInfo = null;
        this.loteSeguido = [];
        this.pujas = [];
        this.seguidoresLote = [];
        this.subscripto = false;
        this.logueado = false;
        this.text = {
            Year: 'Años',
            Month: 'Meses',
            Weeks: 'Semanas',
            Days: 'd',
            Hours: 'h',
            Minutes: 'm',
            Seconds: 's',
            MilliSeconds: 'Milisegundos'
        };
        route.params.subscribe(function (val) {
            _this.authenticationService.logueado$.subscribe(function (b) {
                _this.logueado = b; // por ser BehaviourSubject ya devuelve automáticamente el primer valor
            });
            if (_this.logueado) {
                _this.currentUserInfo = JSON.parse(localStorage.getItem('currentUser'));
                _this.notificacionesForm = _this.formBuilder.group({
                    celular: [_this.currentUserInfo.celular],
                    notificar_sms: [_this.currentUserInfo.notificar_sms],
                    notificar_email: [_this.currentUserInfo.notificar_email],
                    notificar_dispositivo: [_this.currentUserInfo.notificar_dispositivo]
                });
            }
            else {
                _this.notificacionesForm = _this.formBuilder.group({
                    celular: [''],
                    notificar_sms: [false],
                    notificar_email: [false],
                    notificar_dispositivo: [false]
                });
            }
            _this.getSubasta();
        });
    }
    SubastasDetalleComponent.prototype.getSubasta = function () {
        var _this = this;
        this.id = this.route.snapshot.paramMap.get('id');
        console.log('en get subasta ' + this.id);
        this.subastasService.getSubasta(this.id).subscribe(function (data) {
            _this.subasta = data;
            _this.subasta.fechaInicioPuja = _this.subastasService.fechaMysqlAfechaJs(_this.subasta.fechaInicioPuja);
            _this.subasta.fechaFinPuja = _this.subastasService.fechaMysqlAfechaJs(_this.subasta.fechaFinPuja);
            if (_this.subasta.activo === true) {
                if (_this.logueado) {
                    _this.getLotesSeguidos();
                }
                _this.getCantidadUsuariosLote();
                _this.subscribirWebSocket(_this.id, _this);
                _this.getPujas();
                _this.getSeguidoresLote();
                // Las pujas se realizan de a 20.000
                _this.montoPuja = 0;
                _this.ultimoMontoPuja = _this.subasta.ultimoMontoPujado;
                _this.ultimoPujador = _this.subasta.esUltimo;
                _this.enPeriodoPuja = _this.subasta.enPeriodoPuja;
                _this.enPeriodoCompraDirecta = _this.subasta.enPeriodoCompraDirecta;
                _this.vendido = _this.subasta.vendido;
                _this.precioVentaFinal = _this.subasta.precioVentaFinal;
                _this.finalizado = _this.subasta.finalizado;
                _this.enPeriodoAleatorio = _this.subasta.periodoAleatorio;
                _this.urlYoutube = '';
                if (_this.subasta.urlYoutube) {
                    _this.urlYoutube = _this.sanitizer.bypassSecurityTrustResourceUrl(_this.subasta.urlYoutube);
                }
                _this.urlGoogleMaps = '';
                if (_this.subasta.latitud) {
                    _this.urlGoogleMaps = _this.sanitizer.bypassSecurityTrustResourceUrl('https://www.google.com/maps/dir/?api=1&destination=' +
                        _this.subasta.latitud +
                        ',' +
                        _this.subasta.longitud);
                }
                if (_this.subasta.ultimoMontoPujado === 0) {
                    _this.montoPuja = _this.subasta.precioBase;
                }
                else {
                    _this.montoPuja = _this.subasta.ultimoMontoPujado + 20000;
                }
                _this.subastasService.ultimoResultado$.subscribe(function (ultimo) {
                    if (!isEmpty(ultimo)) {
                        _this.ultimoRegistro = ultimo;
                        _this.indexActual = ultimo.findIndex(function (x) { return x.id === _this.subasta.id; });
                        _this.anterior = _this.findDataByIndex(ultimo, _this.indexActual - 1);
                        _this.siguiente = _this.findDataByIndex(ultimo, _this.indexActual + 1);
                    }
                });
                _this.actualizarLabel();
                /*this.subasta.precioBase = this.comma2decimalfloat(
                  this.subasta.precioBase
                );*/
                // muevo aqui el evento que se disparaba en el afterviewinit, ya que primero se disparaba el afterViewInit,
                // y luego se obtenian las imagenes, por lo tanto no se armaba bien el componente carousel
                if (_this.subasta.imagenes.length > 0) {
                    _this.subasta.imagenes.map(function (i) {
                        i.url = environment.baseUrl + '/..' + i.url;
                    });
                    if (typeof _this.owlElement !== 'undefined') {
                        _this.owlElement.to([0]);
                    }
                }
            }
            else {
                // no tenemos imagenes del lote, pero establecemos este timeout para que funcione el carousel de los auspicios
            }
        });
    };
    SubastasDetalleComponent.prototype.findDataByIndex = function (data, index) {
        for (var i = 0, l = data.length; i < l; i++) {
            if (i === index) {
                return data[index];
            }
        }
        return false;
    };
    SubastasDetalleComponent.prototype.actualizarLabel = function () {
        this.labelUltimaPuja = this.ultimoPujador
            ? 'La puja es suya'
            : 'Última puja';
    };
    SubastasDetalleComponent.prototype.getLotesSeguidos = function () {
        var _this = this;
        this.id = this.route.snapshot.paramMap.get('id');
        this.subastasService
            .getLoteSeguido(this.id)
            .subscribe(function (data) {
            if (data.length > 0) {
                _this.loteSeguido = data['0'];
                if (_this.logueado && _this.loteSeguido !== null) {
                    _this.notificacionesForm = _this.formBuilder.group({
                        celular: [_this.currentUserInfo.celular],
                        notificar_sms: [_this.loteSeguido['notificar_sms']],
                        notificar_email: [_this.loteSeguido['notificar_email']],
                        notificar_dispositivo: [_this.loteSeguido['notificar_dispositivo']]
                    });
                }
            }
            else {
                _this.notificacionesForm = _this.formBuilder.group({
                    celular: [_this.currentUserInfo.celular],
                    notificar_sms: [_this.currentUserInfo.notificar_sms],
                    notificar_email: [_this.currentUserInfo.notificar_email],
                    notificar_dispositivo: [_this.currentUserInfo.notificar_dispositivo]
                });
            }
        });
    };
    SubastasDetalleComponent.prototype.ngAfterViewInit = function () {
        // inicializo aquí el carousel en vez de en el document ready.
        console.log('en sub det ngAfterViewInit');
    };
    SubastasDetalleComponent.prototype.openModal = function (template) {
        this.modalRef = this.modalService.show(template);
    };
    Object.defineProperty(SubastasDetalleComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () {
            return this.notificacionesForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    SubastasDetalleComponent.prototype.onSubmit = function () {
        var _this = this;
        this.id = this.route.snapshot.paramMap.get('id'); // id_lote
        // stop here if form is invalid
        if (this.notificacionesForm.invalid) {
            return;
        }
        if (this.f.notificar_dispositivo.value) {
            this.subscribirAPushNotifications();
        }
        this.loading = true;
        var id_lote_seguido = null;
        if (this.loteSeguido !== undefined) {
            id_lote_seguido = this.loteSeguido['id'];
        }
        this.subastasService
            .postLoteSeguido(id_lote_seguido, this.id, this.f.notificar_sms.value, this.f.notificar_email.value, this.f.notificar_dispositivo.value)
            .pipe(first())
            .subscribe(function (data) {
            _this.loteSeguido = data;
            _this.modalRef.hide();
            _this.getCantidadUsuariosLote();
        }, function (error) {
            _this.loading = false;
        });
        if (this.currentUserInfo.celular !== this.f.celular.value) {
            this.usuariosService
                .postUsuariosNotificaciones(this.f.celular.value)
                .pipe(first())
                .subscribe(function (data) {
                _this.currentUserInfo = data;
            });
        }
    };
    SubastasDetalleComponent.prototype.deleteLoteSeguido = function () {
        var _this = this;
        // console.log('delete lote');
        this.id = this.route.snapshot.paramMap.get('id');
        this.subastasService
            .deleteLoteSeguido(this.loteSeguido['id'])
            .subscribe(function (data) {
            console.log('delete lote');
            _this.getCantidadUsuariosLote();
            _this.loteSeguido = [];
            if (_this.logueado) {
                _this.notificacionesForm = _this.formBuilder.group({
                    celular: [_this.currentUserInfo.celular],
                    notificar_sms: [_this.currentUserInfo.notificar_sms],
                    notificar_email: [_this.currentUserInfo.notificar_email],
                    notificar_dispositivo: [_this.currentUserInfo.notificar_dispositivo]
                });
            }
            else {
                _this.notificacionesForm = _this.formBuilder.group({
                    celular: [null],
                    notificar_sms: [false],
                    notificar_email: [false],
                    notificar_dispositivo: [false]
                });
            }
        });
    };
    SubastasDetalleComponent.prototype.getCantidadUsuariosLote = function () {
        var _this = this;
        this.id = this.route.snapshot.paramMap.get('id');
        this.subastasService
            .getCantidadUsuariosLotes(this.id)
            .subscribe(function (data) {
            _this.cantidadUsuariosLote = data[0]['cantidad_lotes'];
        });
    };
    SubastasDetalleComponent.prototype.pujar = function () {
        console.log('pujando', this.id, this.montoPuja);
        if (!confirm('Desea enviar una puja por ' + this.montoPuja + '?')) {
            return false;
        }
        this.pujasService.postPuja(this.id, this.montoPuja).subscribe(function (data) {
            console.log(data);
        });
    };
    SubastasDetalleComponent.prototype.compraDirecta = function () {
        console.log('Compra directa ', this.id, this.subasta.precioCompraDirecta);
        if (!confirm('Desea hacer la compra directa por ' +
            this.subasta.precioCompraDirecta +
            '?')) {
            return false;
        }
        this.pujasService
            .postCompraDirecta(this.id, this.subasta.precioCompraDirecta)
            .subscribe(function (data) {
            console.log(data);
        });
    };
    SubastasDetalleComponent.prototype.subscribirWebSocket = function (id_lote, that) {
        var identificador = that.currentUserInfo
            ? that.currentUserInfo.id
            : 'nadie';
        var connLocal = new ab.Session(environment.websocketUrl + '/' + identificador, function () {
            that.subscripto = true;
            console.log('Subscribiendo a' + 'lote_' + id_lote);
            connLocal.subscribe('lote_' + id_lote, function (topic, data) {
                // This is where you would add the new article to the DOM (beyond the scope of this tutorial)
                var user = JSON.parse(localStorage.getItem('currentUser'));
                if (parseInt(data.monto, 10) === 0) {
                    that.montoPuja = that.subasta.precioBase;
                }
                else {
                    that.montoPuja = parseInt(data.monto, 10) + 20000;
                }
                that.ultimoMontoPuja = parseInt(data.monto, 10);
                that.ultimoPujador = false;
                that.precioVentaFinal = data.monto;
                if (!(data.en_periodo_puja == null)) {
                    that.enPeriodoPuja = data.en_periodo_puja;
                }
                if (!(data.en_periodo_compra_directa == null)) {
                    that.enPeriodoCompraDirecta = data.en_periodo_compra_directa;
                }
                if (!(data.vendido == null)) {
                    that.vendido = data.vendido;
                }
                if (!(data.en_periodo_aleatorio == null)) {
                    that.enPeriodoAleatorio = data.en_periodo_aleatorio;
                }
                if (user) {
                    that.ultimoPujador =
                        data.id_ultimo_pujador === user.id ? true : false;
                }
                if (!(data.finalizado == null)) {
                    that.finalizado = data.finalizado;
                }
                that.actualizarLabel();
                console.log('New article published to category "' + topic + '" : ', data);
                that.getPujas();
            });
        }, function () {
            that.subscripto = false;
            console.warn('WebSocket connection closed');
            setTimeout(function () { return that.subscribirWebSocket(id_lote, that); }, 5000);
        }, { skipSubprotocolCheck: true });
        that.conn = connLocal;
    };
    SubastasDetalleComponent.prototype.subscribirAPushNotifications = function () {
        var _this = this;
        this.swPush
            .requestSubscription({
            serverPublicKey: this.notificacionesPushService.VAPID_PUBLIC_KEY
        })
            .then(function (sub) {
            return _this.notificacionesPushService
                .agregarSubscriptorPush(sub)
                .subscribe(function () { return console.log('Se envió el objeto de suscripción al backend.'); }, function (err) {
                return console.log('No se pudo enviar el objeto de suscripción al backend, razón: ', err);
            });
        })
            .catch(function (err) {
            // tslint:disable-next-line:no-console
            console.debug('Probar build y usar apache o comando http-server -p 8081 -c-1 dist/dobro/');
            console.error('Navegador NO se pudo suscribir a notificaciones', err);
        });
    };
    SubastasDetalleComponent.prototype.ngOnDestroy = function () {
        if (this.subscripto) {
            this.conn.unsubscribe('lote_' + this.id);
            this.subscripto = false;
        }
        console.log('destroy!');
    };
    SubastasDetalleComponent.prototype.separadorMiles = function (input) {
        var ret = input ? input.replace(/,/gi, '.') : null;
        return ret;
    };
    SubastasDetalleComponent.prototype.callback = function ($event) {
        return;
    };
    SubastasDetalleComponent.prototype.getPujas = function () {
        var _this = this;
        if (localStorage.getItem('currentUser')) {
            if (this.permissionsService.hasPermission('ROLE_ADMIN', JSON.parse(localStorage.getItem('currentUser')))) {
                console.log('GetPujas');
                this.id = this.route.snapshot.paramMap.get('id');
                this.subastasService
                    .getSubastaGanador(this.id)
                    .subscribe(function (data) {
                    return (_this.ganador = data);
                });
                this.pujasService.getPujas(this.id).subscribe(function (data) {
                    return (_this.pujas = data);
                });
            }
        }
    };
    SubastasDetalleComponent.prototype.getSeguidoresLote = function () {
        var _this = this;
        if (localStorage.getItem('currentUser')) {
            if (this.permissionsService.hasPermission('ROLE_ADMIN', JSON.parse(localStorage.getItem('currentUser')))) {
                this.id = this.route.snapshot.paramMap.get('id');
                this.subastasService
                    .getSeguidoresLote(this.id)
                    .subscribe(function (data) {
                    return (_this.seguidoresLote = data);
                });
            }
        }
    };
    return SubastasDetalleComponent;
}());
export { SubastasDetalleComponent };
